import { useEffect, useState } from "react";

import { Button, Card, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { STATIONS } from "Constants/Stations";
import { OperationNames } from "Types/operation";
import { IStationData } from "Types/station";

import useCancelOperation from "Hooks/useCancelOperation";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import { changeShowPaths, changeShowReportRightControl } from "Redux/sideSlice";

interface IProps {
  animation: (isActive: boolean, more?: {}) => {};
}

const OperationData: { [key in OperationNames]: string } = {
  "create-path": "ایجاد",
  "edit-path": "ویرایش",
  "station-timing": "زمانبندی",
};

export default function OperationHandler({ animation }: IProps) {
  const dispatch = useAppDispatch();

  const { name, type } = useAppSelector((state) => state.operation);

  const { cancelOperation } = useCancelOperation();

  const [stationData, setStationData] = useState<IStationData>();

  const isActive = name !== null;

  useEffect(() => {
    if (name) {
      const data = STATIONS.filter((station) => station.type === type)[0];
      setStationData({ ...data });
    }
  }, [name, type]);

  const handleCancelOPeration = () => {
    dispatch(changeShowReportRightControl(false));
    dispatch(changeShowPaths(true));
    cancelOperation();
  };

  return (
    <Stack
      direction="row"
      alignItems="stretch"
      spacing={1}
      sx={animation(isActive, { position: "absolute", top: 0, width: "100%" })}
    >
      <Button color="error" variant="contained" onClick={handleCancelOPeration}>
        <CloseIcon />
      </Button>
      <Card sx={{ bgcolor: "secondary.main", color: "common.white", p: 2, width: "100%" }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {stationData?.icon}
          <Typography>
            در حال {name !== null && OperationData[name]} مسیر {stationData?.text} هستید
          </Typography>
        </Stack>
      </Card>
    </Stack>
  );
}
